import { updateSession } from "./updateSession";
import type { StoreCliSessionIdOptions } from '../types/StoreCliSessionIdOptions';

/**
 * Store the CLI-generated session ID
 *
 * Non-critical operation that stores the session ID generated by the CLI
 * for session resumption. Logs warnings on failure but doesn't throw.
 */
export async function storeCliSessionId({
  sessionId,
  cliSessionId
}: StoreCliSessionIdOptions): Promise<void> {
  if (!cliSessionId) {
    return;
  }

  try {
    await updateSession({
      id: sessionId,
      data: { cli_session_id: cliSessionId },
      shouldBroadcast: false // Don't broadcast - non-critical metadata update
    });
  } catch {
    // Non-critical error - continue silently
  }
}
